import { SignupPDVResponseIType } from 'api/signUp/validators/signupPDVvalidator';
import {
  confirmEmailField,
  emailField,
} from 'pages/ContactDataStep/ContactDataStep.config';
import { RegistrationState } from 'store/slices/registration';
import { SignupPDVFormType } from './SignupPDV.config';
import { birthDateField, firstNameField, lastNameField } from 'pages/PersonalDataStep/PersonalDataStep.config';
import { convertTimeStampDateToDateAndTime } from 'utils/functions/convertTimeStampDateToDateAndTime';

export default function mergeRegistrationStateWithPDVserviceResponse(
  prevState: RegistrationState,
  dataToMerge: SignupPDVResponseIType,
  formData: SignupPDVFormType,
): RegistrationState {

  const contactDataStepValues = {
    ...prevState.contactDataStep.formValues,
    [emailField]: dataToMerge.email,
    [confirmEmailField]: dataToMerge.email,
  };

  let birthDate = ""
  if (dataToMerge.birthDate) {
    birthDate = convertTimeStampDateToDateAndTime(dataToMerge.birthDate).date
  }
  const personalDataStepValues = {
    ...prevState.personalDataStep.formValues,
    [firstNameField]: dataToMerge.name,
    [lastNameField]: dataToMerge.surname,
    [birthDateField]: birthDate
  };
  const securityDataStepValues = {
    ...prevState.securityDataStep.formValues,
  };
  return {
    ...prevState,
    contactDataStep: {
      ...prevState.contactDataStep,
      formValues: contactDataStepValues,
    },
    personalDataStep: {
      ...prevState.personalDataStep,
      formValues: personalDataStepValues,
    },
    securityDataStep: {
      ...prevState.securityDataStep,
      formValues: securityDataStepValues,
    },
    pdvCode: {
      fromPdv: true,
      accountCode: formData.codiceConto,
      oldPin: formData.pinConto,
    },
  };
}
